import Turbolinks from 'turbolinks';
window.Turbolinks = Turbolinks;
